import { render, staticRenderFns } from "./getInfo.vue?vue&type=template&id=2fdd7b12&scoped=true"
import script from "./getInfo.vue?vue&type=script&lang=js"
export * from "./getInfo.vue?vue&type=script&lang=js"
import style0 from "./getInfo.vue?vue&type=style&index=0&id=2fdd7b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_a0b2c34ca8cb6aec36211e2e48fb208b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd7b12",
  null
  
)

export default component.exports